// extracted by mini-css-extract-plugin
export default {"versionCardBody":"versionCardBody---BEiiw","changedRecordsList":"changedRecordsList---fCVdX","changedRecord":"changedRecord---_59_z"};